import * as React from "react";

function SvgAwsKinesis(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 256 309"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
      {...{ ...props, ref }}
    >
      <path
        fill="#FCBF92"
        d="M0 172.087l127.754 58.81 127.752-58.81-127.752-5.293z"
      />
      <path fill="#9D5025" d="M128.147 0L.059 63.881v90.136h153.589V12.751z" />
      <path
        fill="#FCBF92"
        d="M.059 217.559l128.162 90.675L256 217.559l-128.055-18.633z"
      />
      <path
        fill="#9D5025"
        d="M128.146 154.017h67.577V57.836l-19.733-7.893-47.844 13.955z"
      />
      <path
        fill="#9D5025"
        d="M175.99 154.017h52.233V91.632l-14.94-4.481-37.293 6.33z"
      />
      <path
        fill="#9D5025"
        d="M213.282 82.26v71.757h42.224L256 81.941l-12.826-5.124z"
      />
      <path
        fill="#F68534"
        d="M128.147 0v154.017h25.5V12.751zM195.724 57.836l-19.733-7.894v104.075h19.732zM228.224 91.632l-14.941-4.48v66.865h14.94zM243.174 154.017H256V81.941l-12.826-5.124zM127.754 184.863v46.033l127.752-31.844v-26.965zM127.754 262.781v45.453L256 244.114V217.56z"
      />
      <path
        fill="#9D5025"
        d="M.059 244.39l127.695 63.844v-45.786L.058 217.558zM0 199.051l127.754 31.845v-46.034L0 172.086z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAwsKinesis);
